import {EventEmitter, Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {take} from 'rxjs/operators';
import {SnackBarService} from '@core/services/snack-bar.service';
import {IWorkflowCollectionState} from '@features/workflow/store/workflow.reducer';
import {Store} from '@ngrx/store';
import {ParticleCacheService} from '@core/services/particle-cache.service';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {getCurrentProject, ProjectState} from '@features/projects/store/reducers/projects.reducer';
import {takeUntil} from 'rxjs/operators';
import {StringUtility} from '@shared/utility/string-utility';
import {LoadProjectSuccessAction} from '@features/projects/store/actions/projects.actions';
import {SyncParticipantsCommand} from "@features/dac6-reporter/commands/dac6-reporter.command";

@Injectable({
  providedIn: 'root',
})
export class LoadParticipantsStartupCommandHandler  implements IPlatformCommandHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  activatedRoute: ActivatedRoute;
  magicLinkModelValueChanged: EventEmitter<any>;
  unSubscribe$ = new Subject<void>();
  private currentProjectId: string;
  constructor(
    private router: Router,
    private fuseSplashScreenService: FuseSplashScreenService,
    private snackBarService: SnackBarService,
    private projectStore: Store<ProjectState>,
    protected commandService: CommandService
  ) {
    this.projectStore.select(getCurrentProject).pipe(takeUntil(this.unSubscribe$)).subscribe(currentProject => {
      // console.log(`got current project:`, currentProject);
      if (currentProject && currentProject.ProjectId) {
        this.currentProjectId = currentProject.ProjectId;
        console.log(this.currentProjectId);
      }
    });
    this.invalidateSubject = new InvalidateSubject();
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any) {
    if(!this.currentProjectId || this.currentProjectId === command.fieldValues['ProjectId']) {
      this.syncManageEntities(command, null, handler, callback);
      return true;
    }
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      const loadProjectCommand = new PlatformCommand('LoadProjectCommand', 'ProjectsApi');
      loadProjectCommand.fieldValues['ProjectId'] = command.fieldValues['ProjectId'] ? command.fieldValues['ProjectId']: this.currentProjectId;
      loadProjectCommand.isCamelCase = true;
      loadProjectCommand.waitForResponse = true;
      loadProjectCommand.projectId = command.fieldValues['ProjectId'] ? command.fieldValues['ProjectId']: this.currentProjectId ;
      this.commandService.executePlatformCommand(loadProjectCommand).pipe(take(1)).subscribe(commandResponse => {
          console.log('[PlatformFilterHandler] Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          let project = commandResponse.fieldValues['ProjectModel'];
          if (project) {
            project = StringUtility.convertKeysCamelToPascal(project);
            this.projectStore.dispatch(new LoadProjectSuccessAction(project, commandResponse.fieldValues['RedirectUrl'], false));
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          //
        this.syncManageEntities(command, project, handler, callback);
        },
        error => {
          this.fuseSplashScreenService.hide();
        });
    }
    return true;
  }

  private syncManageEntities(command: PlatformCommand, project: any, handler: IPlatformToolHandler, callback: any) {
    if ( command.fieldValues.hasOwnProperty('FilteredProjectEntityCodes')) {
      const syncCommand = new SyncParticipantsCommand('', this.magicLinkModel.fieldValues['SyncEntityEndpoint'], command.fieldValues['FilteredProjectEntityCodes']);
      syncCommand.projectId = project ? project.ProjectId : this.currentProjectId;
      this.fuseSplashScreenService.show();
      this.commandService.executeCommand(syncCommand).pipe().subscribe(commandState => {
        this.fuseSplashScreenService.hide();
        if (commandState) {
          if (handler && handler.invalidateSubject) {
            handler.invalidateSubject.invalidate();
          }
          if (callback) {
            callback();
          }
        }
      }, error => {
        console.log(error);
        this.fuseSplashScreenService.hide();
        return this.router.navigateByUrl(command.fieldValues['SelectedTab'].tabData['ReRouteUrl'])
      });
    } else {
      if (handler && handler.invalidateSubject) {
        handler.invalidateSubject.invalidate();
      }
      if (callback) {
        callback();
      }
    }
    // handler.metaData['SyncProjectEntities'] = false;
  }
}
